<template>
  <b-modal :id="modalId" :title="isRental ? 'Add Rental Entry' : 'Add MLS Entry'" hide-footer modal-class="men-modal"
    body-class="men-body" header-class="men-header" title-class="men-title" @hide="onHide">
    <b-form class="men-form" @submit.prevent="mlsEntryUpload">
      <div class="men-grid">
        <b-form-group label="Status" label-class="men-label">
          <b-form-select v-model="MLSuploadForm.status" :options="mlsStatus" class="men-input" />
        </b-form-group>

        <b-form-group label="Price Backup" label-class="men-label" v-if="!isRental">
          <b-form-select v-model="MLSuploadForm.priceBackup" :options="priceBackupOption" class="men-input" />
        </b-form-group>

        <b-form-group label="List Price" label-class="men-label">
          <b-form-input v-model="MLSuploadForm.listPrice" type="text" inputmode="decimal" placeholder="0.00"
            class="men-input" />
        </b-form-group>

        <b-form-group label="Sold Price" label-class="men-label">
          <b-form-input v-model="MLSuploadForm.soldPrice" type="text" inputmode="decimal" placeholder="0.00"
            class="men-input" />
        </b-form-group>

        <b-form-group label="List Price Date" label-class="men-label">
          <b-form-datepicker v-model="MLSuploadForm.listPriceDate" reset-button class="men-input" />
        </b-form-group>

        <b-form-group label="Sold Date" label-class="men-label">
          <b-form-datepicker v-model="MLSuploadForm.soldDate" reset-button class="men-input" />
        </b-form-group>

        <b-form-group label="Buyer Incentives" label-class="men-label" v-if="!isRental">
          <b-form-input v-model="MLSuploadForm.buyerIncentives" type="text" inputmode="decimal" placeholder="0.00"
            class="men-input" />
        </b-form-group>

        <b-form-group label="Realtor Incentives" label-class="men-label" v-if="!isRental">
          <b-form-input v-model="MLSuploadForm.realtorIncentives" type="text" inputmode="decimal" placeholder="0.00"
            class="men-input" />
        </b-form-group>

        <b-form-group label="Back-up Text" label-class="men-label" class="men-col-full">
          <b-form-input v-model="MLSuploadForm.backupText" type="text" placeholder="Backup notes" class="men-input" />
        </b-form-group>

        <b-form-group label="Back-up File" label-class="men-label" class="men-col-full">
          <b-form-file v-model="MLSuploadForm.floorPlan" :state="Boolean(MLSuploadForm.floorPlan)"
            placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." class="men-input" />
        </b-form-group>
      </div>

      <div class="men-actions">
        <button type="button" class="men-btn men-btn--ghost" @click="cancel">Cancel</button>
        <button type="submit" class="men-btn men-btn--primary" :disabled="submitting">
          {{ submitting ? 'Submitting…' : 'Submit' }}
        </button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { BACKEND_URL } from '../../variables';

const DEFAULT_FORM = () => ({
  status: 11482,
  listPrice: '',
  listPriceDate: null,
  soldDate: null,
  soldPrice: '',
  buyerIncentives: '',
  realtorIncentives: '',
  backupText: '',
  floorPlan: null,
  priceBackup: '',
});

export default {
  name: 'MlsEntryNewModal',
  props: {
    cid: { type: [Number, String], default: null },
    isRental: { type: Boolean, default: false },
    modalId: { type: String, default: 'mls-entry-new' },
  },
  emits: ['submitted'],
  data() {
    return {
      MLSuploadForm: DEFAULT_FORM(),
      submitting: false,
      mlsStatus: [
        { text: '', value: 11482 },
        { text: 'Active', value: 8197 },
        { text: 'Sold', value: 8198 },
        { text: 'Unreleased', value: 23440 },
      ],
      priceBackupOption: [
        { text: '', value: '' },
        { text: 'Verified', value: 'Verified' },
        { text: 'Semi-Verified', value: 'Semi-Verified' },
        { text: 'Educated Estimated', value: 'Educated Estimated' },
      ],
    };
  },
  methods: {
    cancel() {
      this.$bvModal.hide(this.modalId);
    },
    onHide() {
      this.MLSuploadForm = DEFAULT_FORM();
      this.submitting = false;
    },
    mlsEntryUpload() {
      if (!this.cid) {
        this.$bvToast.toast('Missing project reference (cid).', {
          title: 'Error', autoHideDelay: 4000, variant: 'danger',
        });
        return;
      }
      this.submitting = true;
      const formData = new FormData();

      formData.append('status', this.MLSuploadForm.status);
      formData.append('listPrice', this.MLSuploadForm.listPrice);
      formData.append('listPriceDate', this.MLSuploadForm.listPriceDate);
      formData.append('files', this.MLSuploadForm.floorPlan);
      formData.append('backupText', this.MLSuploadForm.backupText);
      formData.append('buyerIncentives', this.MLSuploadForm.buyerIncentives);
      formData.append('realtorIncentives', this.MLSuploadForm.realtorIncentives);
      formData.append('priceBackup', this.MLSuploadForm.priceBackup);
      formData.append('cid', this.cid);
      formData.append('soldDate', this.MLSuploadForm.soldDate);
      formData.append('soldPrice', this.MLSuploadForm.soldPrice);
      formData.append('uid', this.$route.query.uid || '');
      if (this.isRental) formData.append('newEntry', true);

      const urlEndpoint = this.isRental
        ? 'api/presale_mls_rental_creation'
        : 'api/presale_mls_entry_add_entry';

      $.ajax({
        type: 'POST',
        url: BACKEND_URL + urlEndpoint,
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(() => {
          this.$bvToast.toast('MLS Entry uploaded successfully.', {
            title: 'Success', autoHideDelay: 4000, variant: 'success',
          });
          this.$bvModal.hide(this.modalId);
          this.$emit('submitted');
        })
        .fail((err) => {
          console.error('Error uploading MLS entry:', err);
          this.$bvToast.toast('An error occurred while uploading. Please try again.', {
            title: 'Error', autoHideDelay: 4000, variant: 'danger',
          });
        })
        .always(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style>
/* ── MLS Entry New Modal ─────────────────────────────── */
.men-modal .modal-dialog {
  max-width: min(640px, 96vw);
}

.men-modal .modal-content {
  border: 1px solid #E9E8E9;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(18, 40, 63, 0.28);
}

.men-header {
  background: #12283F;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 13px 18px;
  align-items: center;
}

.men-title {
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
}

.men-header .close {
  color: rgba(255, 255, 255, 0.85);
  opacity: 1;
  text-shadow: none;
  font-size: 1.4rem;
}

.men-body {
  background: #fff;
  padding: 18px;
}

.men-form {
  font-family: Poppins, sans-serif;
  color: #12283F;
}

.men-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}

.men-col-full {
  grid-column: span 2;
}

.men-label {
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #343376;
  margin-bottom: 4px;
}

.men-input .form-control,
.men-input .custom-select,
.men-input input,
.men-input .b-form-datepicker,
.men-input .custom-file-label {
  font-family: Poppins, sans-serif;
  font-size: 13px;
  color: #12283F;
  border: 1px solid #C9CCD2;
  border-radius: 6px;
  background: #fff;
}

.men-input .form-control:focus,
.men-input .custom-select:focus {
  border-color: #343376;
  box-shadow: 0 0 0 2px rgba(52, 51, 118, 0.15);
}

.men-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #EEF0F4;
}

.men-btn {
  height: 34px;
  padding: 0 18px;
  border-radius: 6px;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.04em;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.12s;
}

.men-btn--ghost {
  background: #fff;
  color: #545454;
  border-color: #C9CCD2;
}

.men-btn--ghost:hover {
  background: #F7F8FB;
  color: #12283F;
}

.men-btn--primary {
  background: #343376;
  color: #fff;
  border-color: #343376;
}

.men-btn--primary:hover:not(:disabled) {
  background: #2a2961;
  border-color: #2a2961;
}

.men-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Dark mode ─────────────────────────────── */
html.dark .men-modal .modal-content {
  background: #152030;
  border-color: rgba(255, 255, 255, 0.08);
}

html.dark .men-body {
  background: #152030;
}

html.dark .men-form {
  color: #d6e4f0;
}

html.dark .men-label {
  color: #a5a8e8;
}

html.dark .men-input .form-control,
html.dark .men-input .custom-select,
html.dark .men-input input,
html.dark .men-input .custom-file-label {
  background: #0E1B2C;
  border-color: rgba(255, 255, 255, 0.12);
  color: #d6e4f0;
}

html.dark .men-actions {
  border-color: rgba(255, 255, 255, 0.08);
}

html.dark .men-btn--ghost {
  background: #1d3048;
  border-color: rgba(255, 255, 255, 0.12);
  color: rgba(214, 228, 240, 0.7);
}

html.dark .men-btn--ghost:hover {
  background: #243a55;
  color: #d6e4f0;
}

html.dark .men-btn--primary {
  background: #FC5868;
  border-color: #FC5868;
}

html.dark .men-btn--primary:hover:not(:disabled) {
  background: #e54b5b;
  border-color: #e54b5b;
}
</style>
